module.exports = __webpack_public_path__ + "static/media/world-cup.3084b13f.png";